import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./PatientAppointmentsUIHelpers";

const PatientAppointmentsUIContext = createContext();

export function usePatientAppointmentsUIContext() {
  return useContext(PatientAppointmentsUIContext);
}

export const PatientAppointmentsUIConsumer = PatientAppointmentsUIContext.Consumer;

export function PatientAppointmentsUIProvider({ PatientAppointmentsUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams, 
    openDetailPatientAppointmentPage: PatientAppointmentsUIEvents.openDetailPatientAppointmentPage
  };

  return (
    <PatientAppointmentsUIContext.Provider value={value}>
      {children}
    </PatientAppointmentsUIContext.Provider>
  );
}
